import React, { useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SearchBatches from './SearchBatches';
import ReportRes from './ReportRes';
import UniDialog from '../Common/UniDialog';
import { handleScanReport, openScanReport } from '../../reducers/uiSlice';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        minHeight: '80vh'
    },
}));

function ScanReport() {
    const classes = useStyles();
    const {t} = useTranslation('scanReport');
    const dispatch = useDispatch();

    const openModal = useSelector(openScanReport);

    return (
        <UniDialog
            title={t('title_scan_report')}
            fullWidth
            maxWidth='xl'
            disableDefaultButtons
            open={openModal}
            onClose={handleClose}
        >
            <SearchBatches/>
            <ReportRes/>
        </UniDialog>
    );

    /**
     * close the dialog
    */
    function handleClose() {
        dispatch(handleScanReport(false))
    }
}

export default ScanReport;